module.exports = __webpack_public_path__ + "static/media/20_A.673c45f4.png";